
import $ from 'jquery';



const reinit_8select = ( target ) => {

	const $target = $( target );
	const variant = $target.find('input[name="aid"]').val();
	if ( window._8select ) {
		window._8select.updateWidgetSku('8.SET', variant);
		window._8select.updateWidgetSku('8.SIMILAR', variant);
	}
};

$( document ).on( 'article_detail_reload.en', (evt) => reinit_8select( evt.target ) );

export {reinit_8select};
